import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from 'apps/ciptech/src/environments/environment';
import { map, tap } from 'rxjs/operators';
import { CryptoService } from '../services/crypto.service';
import { Observable, of } from 'rxjs';
import { EmailMessage, EmailResponse, Email } from '@ciptech/classes';

@Injectable()
export class WsGlobalService {
  private endpoint = `/api/WsGeneral`;
  private key = 'kaMSTOLdhf';

  constructor(
    private http: HttpClient,
    private handler: HttpBackend,
    private crypto: CryptoService
  ) { }

  private get config() {
    // config = { tc: 3.5 };
    let config: any = {};
    try {
      const storage = localStorage.getItem(this.key);
      if (storage) {
        config = JSON.parse(this.crypto.get(storage));
        const diff = new Date().getTime() - new Date(config.created).getTime();
        // Duración 6 horas
        if (!config.created || diff > 1000 * 60 * 60 * 6) {
          config = {};
          localStorage.removeItem(this.key);
          throw new TypeError('configuration expired');
        }
      }
    } catch (error) { }

    return config;
  }

  private set config(value: any) {
    if (!value.created) {
      value.created = new Date();
    }
    localStorage.setItem(this.key, this.crypto.set(JSON.stringify(value)));
  }

  TasaCambio(ctx?: any): Observable<number> {
    const config = this.config;
    if (config.tc) {
      return of(config.tc);
    }

    return this.http.get<number>(`${this.endpoint}/tasa-cambio`, { headers: { context: ctx || '' } })
      .pipe(
        tap(res => {
          config.tc = res;
          this.config = config;
        })
      );

    /* var http = new HttpClient(this.handler);
    return http.get<any>(`https://deperu.com/api/rest/cotizaciondolar.json`)
      .pipe(
        tap(res => {
          config.tc = res.Cotizacion[0].Venta;
          this.config = config;
        }),
        map(res => {
          return res.Cotizacion[0].Venta;
        })
      ); */
  }

  EnviarCorreo(data: EmailMessage, ctx?: string): Observable<EmailResponse> {
    if (!data.Emisor) {
      data.Emisor = new Email(environment.EMAIL_BASE);
    }
    return this.http.post<EmailResponse>(`${this.endpoint}/enviar-email`, data, { headers: { context: ctx || '.p-email' } });
  }

}
